'use client';

import LinkedinOutlined from '@/assets/icons/LinkedinOutlined';
import RefreshIcon from '@/assets/icons/Refresh';
import NavigationLink from '@/components/NavigationLink';
import ResponsiveImage from '@/components/ResponsiveImage';
import { Button } from '@/components/ui/button';
import { ScrollArea } from '@/components/ui/scroll-area';

import './styles.scss';
import { cn } from '@/lib/utils';
import { useState } from 'react';

export default function Member(props) {
  const [showDescription, setShowDescription] = useState(false);
  const [isFlipped, setIsFlipped] = useState(false);

  const { title, role, avatar, description, linkedIn, imageProps = {} } = props;

  const frontSideDummy = (
    <div className='invisible h-full flex flex-col px-6 py-5' aria-hidden>
      {avatar && (
        <div className='size-60 md:size-64 mb-6 xl:mb-2 self-center rounded-full border-2 border-primary mx-auto overflow-clip' />
      )}
      {title && <p className='h5'>{title}</p>}
      {role && <p>{role}</p>}
      {linkedIn && (
        <NavigationLink href='' className='linkedin relative mt-4 w-fit z-10 text-primary pointer-events-none'>
          <LinkedinOutlined className='size-8' />
          <span className='sr-only'>linked in</span>
        </NavigationLink>
      )}
    </div>
  );

  const toggleShow = () => {
    setShowDescription(!showDescription);
    setIsFlipped(true);
  };

  return (
    <div
      className={cn('member group flex flex-col rounded relative max-w-md md:max-w-full w-full overflow-visible', {
        'show-details': showDescription
      })}
    >
      <div className='flip-card-inner w-full h-full text-center'>
        {/* Front Side */}
        {frontSideDummy}
        <div className='flip-card-front w-full h-full flex flex-col items-start px-6 py-5 bg-white  border-4 border-primary'>
          {avatar && (
            <div className='size-60 md:size-64 mb-6 xl:mb-2 self-center rounded-full border-2 border-primary mx-auto overflow-clip'>
              <ResponsiveImage file={avatar} className='size-full object-cover' {...imageProps} />
            </div>
          )}
          {title && <p className='title h5'>{title}</p>}
          {role && <p className='role'>{role}</p>}
          {linkedIn && (
            <NavigationLink href={linkedIn} className='linkedin relative mt-2 w-fit z-10 text-primary' target='_blank'>
              <LinkedinOutlined className='size-8' />
              <span className='sr-only'>linked in</span>
            </NavigationLink>
          )}
        </div>

        {/* Back Side */}
        <div
          className={cn('flip-card-back w-full h-full bg-background text-white [--animation-duration:0.25s]', {
            'animate-remove-z-index': !showDescription && isFlipped,
            'animate-add-z-index': showDescription
          })}
        >
          <ScrollArea
            className='h-full px-4 sm:px-6 xl:px-10 text-start'
            classNames={{ thumb: 'rounded-none bg-zinc-300' }}
          >
            {title && <p className='title h5 pt-4 sm:pt-6 xl:pt-10'>{title}</p>}
            {role && <p className='role'>{role}</p>}
            {description && <p className='description mt-2 pb-16 sm:pb-6 xl:pb-10'>{description}</p>}
          </ScrollArea>
        </div>
      </div>

      <Button variant='text' size='icon' className='absolute right-6 bottom-5 z-10' onClick={toggleShow}>
        <RefreshIcon
          className={cn('transition-transform shrink-0 py-0.5', {
            'rotate-180': showDescription
          })}
        />
        <span className='sr-only'>{showDescription ? 'show description' : 'hide description'}</span>
      </Button>
    </div>
  );
}
